exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HistoryParameters-HistoryParameters-Table_container{width:100%;border-spacing:0;border-collapse:collapse}.HistoryParameters-HistoryParameters-row_container{padding:0 15px;padding:0 .9375rem;margin:0 auto;max-width:1280px}.HistoryParameters-HistoryParameters-header_color{border:1px solid #0376a3;background:#0376a3;color:#fff}.HistoryParameters-HistoryParameters-data_color{background:#fff;border:1px solid #0376a3}@media (min-width:721px){.HistoryParameters-HistoryParameters-data_color{min-width:8rem}}.HistoryParameters-HistoryParameters-spirotech_header_color{background:#fae04e}.HistoryParameters-HistoryParameters-spirotech_data_color{background:#fff;border:1px solid #fae04e}@media (min-width:721px){.HistoryParameters-HistoryParameters-spirotech_data_color{min-width:8rem}}.HistoryParameters-HistoryParameters-red{background:red}.HistoryParameters-HistoryParameters-center{text-align:center}.HistoryParameters-HistoryParameters-button{border:none;background:none}", ""]);

// exports
exports.locals = {
	"Table_container": "HistoryParameters-HistoryParameters-Table_container",
	"row_container": "HistoryParameters-HistoryParameters-row_container",
	"header_color": "HistoryParameters-HistoryParameters-header_color",
	"data_color": "HistoryParameters-HistoryParameters-data_color",
	"spirotech_header_color": "HistoryParameters-HistoryParameters-spirotech_header_color",
	"spirotech_data_color": "HistoryParameters-HistoryParameters-spirotech_data_color",
	"red": "HistoryParameters-HistoryParameters-red",
	"center": "HistoryParameters-HistoryParameters-center",
	"button": "HistoryParameters-HistoryParameters-button"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/HistoryParameters/HistoryParameters.css
// module id = 1098
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20